const KakaoLoginBtn = ({ metaInfo = {} }) => {
    if (!window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_JS_KEY);
    }

    function loginWithKakao() {
        const params = {
            redirectUri: process.env.REACT_APP_KAKAO_REDIRECT_URL,
            scope: 'account_email',
            state: new URLSearchParams(metaInfo).toString()
        };

        // if (signUpSessionId != null)
        //   params['state'] = new URLSearchParams({signUpSessionId: signUpSessionId}).toString()

        window.Kakao.Auth.authorize(params);
    }

    function displayToken() {
        const token = getCookie('authorize-access-token');

        if (token) {
            window.Kakao.Auth.setAccessToken(token);
            window.Kakao.Auth.getStatusInfo()
                .then(function (res) {
                    if (res.status === 'connected') {
                        window.Kakao.Auth.getAccessToken();
                    }
                })
                .catch(_ => {
                    window.Kakao.Auth.setAccessToken(null);
                });
        }
    }

    function getCookie(name) {
        const parts = document.cookie.split(name + '=');
        if (parts.length === 2) {
            return parts[1].split(';')[0];
        }
    }

    displayToken()

    return (
        <div>
            <button className="login-btn" onClick={loginWithKakao}>
                <img className="icon kakao" alt={"카카오 로그인"} src="/assets/img/kakao_logo.png" />
            </button>
        </div>
    )
}

export default KakaoLoginBtn;

